import React, { useEffect } from "react";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// Import Route Pages
import Home from "../pages/Home";
import AmministrazioneTrasparente from "../pages/AmministrazioneTrasparente";

import PrivacyPolicy from "../pages/PrivacyPolicy";
import CookiePolicy from "../pages/CookiePolicy";

const BaseRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Routes>
      {/* Main Route */}
      <Route path="/" element={<Home />} />
      <Route path="/amministrazione-trasparente" element={<AmministrazioneTrasparente />} />

      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/cookie-policy" element={<CookiePolicy />} />

      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

export default BaseRoutes;
